import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, Button, Stack, Typography } from '@mui/material'
import React, { FC, useContext } from 'react'
import { generatePath } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import useDownloadInvoice from './useDownloadInvoice'

const SuccessContent: FC = () => {
  const { apiKey } = useContext(PaymentPortalContext)
  const invoicePath = generatePath(AppRoutes.CUSTOMER_PORTAL_INVOICE, {
    apiKey
  })
  const { loading, downloadInvoice } = useDownloadInvoice(apiKey)

  return (
    <Box
      flexDirection="column"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100%' }}>
      <Box display="flex" flexDirection="row">
        <CheckCircleIcon color="success" sx={{ mr: 1 }} />
        <Typography variant="h3">
          Thank you for your payment! You may now close this browser tab.
        </Typography>
      </Box>
      <Stack sx={{ mt: 1 }} spacing={1}>
        <Button variant="outlined" onClick={() => window.open(invoicePath)}>
          View Invoice
        </Button>
        <Button
          variant="contained"
          onClick={downloadInvoice}
          disabled={loading}>
          {loading ? 'Sending...' : 'Download Invoice'}
        </Button>
      </Stack>
    </Box>
  )
}

export default SuccessContent
